import {Component} from '@angular/core';

@Component({
  selector: 'app-ipe-loading-modal',
  standalone: true,
  templateUrl: './ipe-loading-modal.component.html',
  styleUrls: ['./ipe-loading-modal.component.scss'],
})
export class IpeLoadingModalComponent {
  image1 = '../../../assets/images/icons/loading/logo.png';
  image2 = '../../../assets/images/icons/loading/logo-border.png';
}
